import { useSelector } from "react-redux";
import { menuImage } from "../../utils";

const CategoryImage = ({ image, title }) => {
  const setting = useSelector((state) => state.meta?.setting);

  return (
    <img
      src={menuImage(image, setting.logo)}
      alt={title}
      className="rounded img-fluid"
      style={{ aspectRatio: 1 / 1, height: 70, width: 70 }}
    />
  );
};

export default CategoryImage;
